import React from 'react';
import { Shield, UserPlus, Clock, Check, Calendar, Brain, Target } from 'lucide-react';

const GuaranteeSection = () => {
  return (
    <section className="py-16 md:py-20 bg-white border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Simple header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center mb-3 bg-[#c4ffa0]/20 px-3 py-1 rounded-full text-xs md:text-sm">
            <span className="mr-1 md:mr-2">🛡️</span>
            <span className="text-[#2d4a1e] font-medium">RISK-FREE GUARANTEE</span>
            <span className="ml-1 md:ml-2">🛡️</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3">We've Got Your Back</h2>
          {/* <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            Try Kinos with complete confidence. Your success is guaranteed.
          </p> */}
        </div>
        
        {/* Main guarantee box - simplified, direct communication */}
        <div className="bg-[#c4ffa0]/10 rounded-xl shadow-lg overflow-hidden mb-10 md:mb-14">
          <div className="p-6 md:p-8">
            <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
              {/* Shield icon for trust */}
              <div className="bg-white rounded-full p-5 shadow-md">
                <Shield className="w-10 h-10 md:w-14 md:h-14 text-[#2d4a1e]" strokeWidth={1.5} />
              </div>
              
              {/* Direct guarantee statement */}
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">10 Hours Saved Guarantee</h3>
                <p className="text-base md:text-lg text-gray-700">
                  Save at least 10 hours in your first 30 days, or we'll extend your subscription for free until you do.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Two simple boxes with core promises */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {/* Free trial box */}
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 md:p-8 hover:shadow-lg transition-all duration-300 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="bg-[#c4ffa0]/10 rounded-full p-3 mb-4">
              <Clock className="w-6 h-6 text-[#2d4a1e]" strokeWidth={1.5} />
            </div>
            <h3 className="text-lg md:text-xl font-bold mb-2 text-gray-800">14-Day Free Trial</h3>
            {/* <p className="text-gray-600">
              Experience everything Kinos offers with zero risk or commitment.
            </p> */}
            
            <ul className="mt-4 space-y-2 text-left">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-[#2d4a1e] mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 text-sm">Full access to all features</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-[#2d4a1e] mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 text-sm">No credit card required</span>
              </li>
            </ul>
          </div>
          
          {/* Support box */}
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 md:p-8 hover:shadow-lg transition-all duration-300 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="bg-[#c4ffa0]/10 rounded-full p-3 mb-4">
              <Brain className="w-6 h-6 text-[#2d4a1e]" strokeWidth={1.5} />
            </div>
            <h3 className="text-lg md:text-xl font-bold mb-2 text-gray-800">Peronalized Support</h3>
            {/* <p className="text-gray-600">
              Our AI and team are with you every step to ensure your marketing success.
            </p> */}
            
            <ul className="mt-4 space-y-2 text-left">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-[#2d4a1e] mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 text-sm">Personalize onboarding session</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-[#2d4a1e] mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 text-sm">Feature requests prioritized</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Clear CTA */}
        <div className="mt-10 md:mt-16 text-center ">
          <div className="bg-gradient-to-r from-[#c4ffa0] to-[#b3ee90] rounded-2xl p-8 shadow-xl">
            <h3 className="text-[#2d4a1e] text-xl md:text-2xl font-bold mb-3">
              Ready to End Marketing Chaos?
            </h3>
            {/* <p className="text-[#2d4a1e]/80 mb-6 text-sm md:text-base max-w-2xl mx-auto">
              See how Kinos can help you consolidate, automate, and optimize all your marketing efforts in one AI-powered platform. 
            </p> */}
            <a 
              href="https://calendly.com/usekinos"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <button className="px-8 py-4 bg-white text-[#2d4a1e] text-sm md:text-base font-bold rounded-xl hover:shadow-xl transition-all duration-300 inline-flex items-center hover:scale-105 group">
                <Calendar className="w-5 h-5 mr-3 group-hover:rotate-12 transition-transform" />
                <span>Book Your Free Demo</span>
                <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
              </button>
            </a>
            <p className="mt-4 text-[#2d4a1e]/80 text-xs md:text-sm">
              15-minute demo • No commitment • See results in real-time
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;